import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    // 下载app
    {
        path: '/downloadapp',
        name: 'downloadapp',
        component: () =>
            import ("@/views/download-app/index"),
    },
    // 登录
    {
        path: '/',
        component: () =>
            import ("@/views/login/index"),
        redirect: '/login',
        children: [{
            path: '/login',
            name: 'login',
            component: () =>
                import ("@/views/login/index")
        }]
    },
    // 注册
    {
        path: '/register',
        name: 'register',
        component: () =>
            import ("@/views/register/index")
    },
    // 首页
    {
        path: '/home',
        name: 'home',
        component: () =>
            import ("@/views/home/index"),
        redirect: '/welcome', // 路由重定向
        children: [
            // 欢迎页面子路由配置
            {
                path: '/welcome',
                name: 'welcome',
                component: () =>
                    import ("@/views/home-manage/index")
            },
        ]
    },
    // 校区管理
    {
        path: '/',
        name: 'campus-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [{
            path: '/campusmanagement',
            name: 'campusmanagement',
            component: () =>
                import ("@/views/campus-manage/index")
        }]
    },
    // 教务管理
    {
        path: '/',
        name: 'education-manage',
        component: () =>
            import ("@/views/home/index"),
        // redirect: '/welcome', // 路由重定向
        children: [
            // 分校区管理
            {
                path: '/campus',
                name: 'campus',
                component: () =>
                    import ("@/views/education-manage/campus/index")
            },
            // 分校区管理 新建校区
            {
                path: '/campusnew',
                name: 'campusnew',
                component: () =>
                    import ("@/views/education-manage/campus/campusnew/index")
            },
            // 分校区管理 编辑校区
            {
                path: '/campusedit',
                name: 'campusedit',
                component: () =>
                    import ("@/views/education-manage/campus/campusedit/index")
            },
            // 员工管理
            {
                path: '/staff',
                name: 'staff',
                component: () =>
                    import ("@/views/education-manage/staff/index")
            },
            // 班级管理
            {
                path: '/classs',
                name: 'classs',
                component: () =>
                    import ("@/views/education-manage/classs/index")
            },
            // 班级管理 班级学员/班级员工
            {
                path: '/studentemplist',
                name: 'studentemplist',
                component: () =>
                    import ("@/views/education-manage/classs/studentemplist/index")
            },
            // 班级管理 添加学员
            {
                path: '/addstudentlist',
                name: 'addstudentlist',
                component: () =>
                    import ("@/views/education-manage/classs/addstudentlist/index")
            },
            // 班级管理 添加员工
            {
                path: '/addemplist',
                name: 'addemplist',
                component: () =>
                    import ("@/views/education-manage/classs/addemplist/index")
            },
            // 学员管理
            {
                path: '/student',
                name: 'student',
                component: () =>
                    import ("@/views/education-manage/student/index")
            },
        ]
    },
    // 教材管理
    {
        path: '/',
        name: 'textbook-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [
            // 教材管理 学校教材区
            {
                path: '/schoolbook',
                name: 'schoolbook',
                component: () =>
                    import ("@/views/textbook-manage/schoolbook/index")
            },
            // 教材管理 自制教材区
            {
                path: '/selfbook',
                name: 'selfbook',
                component: () =>
                    import ("@/views/textbook-manage/selfbook/index")
            },
            // 教材管理 添加教材
            {
                path: '/selfbookadd',
                name: 'selfbookadd',
                component: () =>
                    import ("@/views/textbook-manage/selfbook/selfbookadd/index")
            },
            // 教材管理 新建/编辑教材
            {
                path: '/addBook',
                name: 'addBook',
                component: () =>
                    import ("@/views/textbook-manage/selfbook/addBook/index")
            },
            // 教材管理 新建/编辑单元
            {
                path: '/addBookChapter',
                name: 'addBookChapter',
                component: () =>
                    import ("@/views/textbook-manage/selfbook/addBookChapter/index")
            },
            // 教材管理 新建/编辑章节
            {
                path: '/addBookPageFromChapter',
                name: 'addBookPageFromChapter',
                component: () =>
                    import ("@/views/textbook-manage/selfbook/addBookPageFromChapter/index")
            },
            // 教材管理 新建/编辑页面
            {
                path: '/addBookPageArea',
                name: 'addBookPageArea',
                component: () =>
                    import ("@/views/textbook-manage/selfbook/addBookPageArea/index")
            },
        ]
    },
    // 素材中心
    {
        path: '/',
        name: 'material-center',
        component: () =>
            import ("@/views/home/index"),
        children: [{
            path: '/statistics',
            name: 'statistics',
            component: () =>
                import ("@/views/material-center/statistics/index")
        }]
    },
    // 小程序管理
    {
        path: '/',
        name: 'small-program-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [
            // 小程序管理 小程序界面
            {
                path: '/minifirstpage',
                name: 'minifirstpage',
                component: () =>
                    import ("@/views/small-program-manage/minifirstpage/index")
            },
            // 小程序管理 系统设置
            {
                path: '/minisysconfig',
                name: 'minisysconfig',
                component: () =>
                    import ("@/views/small-program-manage/minisysconfig/index")
            },
            // 小程序管理 教材设置
            {
                // 规则编辑独立于教材内容草稿；路由存在不表示有权限，页面/API 仍核对实际 miniid 范围。
                path: '/moduleAccess',
                name: 'moduleAccess',
                component: () => import('@/views/small-program-manage/moduleAccess/index'),
            },
            {
                path: '/SettingMaterial',
                name: 'SettingMaterial',
                component: () =>
                    import ("@/views/small-program-manage/SettingMaterial/index")
            },
            // 小程序管理 添加教材
            {
                path: '/addMaterial',
                name: 'addMaterial',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/small-program-manage/addMaterial/index")
            },
          // 小程序管理 产品信息管理
          {
            path: '/miniProduct',
            name: 'miniProduct',
            component: () =>
              import ("@/views/small-program-manage/miniProduct/index")
          },
        ]
    },
    // 功能模块
    {
        path: '/',
        name: 'functional-module',
        component: () =>
            import ("@/views/home/index"),
        children: [
            // 功能模块 磨耳朵
            {
                path: '/listening',
                name: 'listening',
                component: () =>
                    import ("@/views/functional-module/listening/index")
            },
            // 功能模块 上传音频
            {
                path: '/listeningear',
                name: 'listeningear',
                component: () =>
                    import ("@/views/functional-module/listening/listeningear/index")
            },
            // 功能模块 微剧场
            {
                path: '/watching',
                name: 'watching',
                component: () =>
                    import ("@/views/functional-module/watching/index")
            },
            // 功能模块 上传视频
            {
                path: '/watchingear',
                name: 'watchingear',
                component: () =>
                    import ("@/views/functional-module/watching/watchingear/index")
            },
            // 功能模块 制作配音
            {
                path: '/watchingDubList',
                name: 'watchingDubList',
                component: () =>
                    import ("@/views/functional-module/watching/watchingDubList/index")
            },
            // 趣配音：章节、视频、打轴、作品、统计。不走微剧场权益。
            {
                path: '/dubbing',
                name: 'dubbing',
                component: () => import('@/views/functional-module/dubbing/index')
            },
            {
                path: '/dubbingVideos',
                name: 'dubbingVideos',
                component: () => import('@/views/functional-module/dubbing/videos')
            },
            {
                path: '/dubbingAxis',
                name: 'dubbingAxis',
                component: () => import('@/views/functional-module/dubbing/axis')
            },
            {
                path: '/dubbingWorks',
                name: 'dubbingWorks',
                component: () => import('@/views/functional-module/dubbing/works')
            },
            {
                path: '/dubbingStats',
                name: 'dubbingStats',
                component: () => import('@/views/functional-module/dubbing/stats')
            },
            // 功能模块 词汇练习
            {
                path: '/testing',
                name: 'testing',
                component: () =>
                    import ("@/views/functional-module/testing/index")
            },
            // 功能模块 上产闪卡
            {
                path: '/testingear',
                name: 'testingear',
                component: () =>
                    import ("@/views/functional-module/testing/testingear/index")
            },
            // 功能模块 新建闪卡
            {
                path: '/testingDubList',
                name: 'testingDubList',
                component: () =>
                    import ("@/views/functional-module/testing/testingear/testingDubList/index")
            },
            // 功能模块 修改闪卡
            {
                path: '/testingupdate',
                name: 'testingupdate',
                component: () =>
                    import ("@/views/functional-module/testing/testingear/testingupdate/index")
            },
            // 功能模块 趣跟读
            {
                path: '/sentencepractice',
                name: 'sentencepractice',
                component: () =>
                    import ("@/views/functional-module/sentencepractice/index")
            },
            // 功能模块 上传绘本
            {
                path: '/sentencepracticeear',
                name: 'sentencepracticeear',
                component: () =>
                    import ("@/views/functional-module/sentencepractice/sentencepracticeear/index")
            },
            // 功能模块 新建绘本
            {
                path: '/sentencepracticeDubList',
                name: 'sentencepracticeDubList',
                component: () =>
                    import ("@/views/functional-module/sentencepractice/sentencepracticeear/sentencepracticeDubList/index")
            },
            // 功能模块 修改绘本
            {
                path: '/sentencepracticeupdate',
                name: 'sentencepracticeupdate',
                component: () =>
                    import ("@/views/functional-module/sentencepractice/sentencepracticeear/sentencepracticeupdate/index")
            },
        ]
    },
    //习题测试
    {
        path: '/',
        name: 'exercise-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [{
            path: '/makeexercises',
            name: 'makeexercises',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/index")
        }, {
            path: '/exerciselibrary',
            name: 'exerciselibrary',
            component: () =>
                import ("@/views/exercise-manage/exerciselibrary/index")
        }, {
            path: '/bigquestionlist',
            name: 'bigquestionlist',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/bigquestionlist/index")
        }, {
            path: '/smallquestionlist',
            name: 'smallquestionlist',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/smallquestionlist/index")
        }, {
            path: '/single-choice',
            name: 'single-choice',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/single-choice")
        }, {
            path: '/judge',
            name: 'judge',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/judge")
        }, {
            path: '/listening-choice',
            name: 'listening-choice',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/listening-choice")
        }, {
            path: '/gap-filling',
            name: 'gap-filling',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/gap-filling")
        }, {
            path: '/multiple-choice',
            name: 'multiple-choice',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/multiple-choice")
        }, {
            path: '/cloze-test',
            name: 'cloze-test',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/cloze-test")
        }, {
            path: '/ranking-question',
            name: 'ranking-question',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/ranking-question")
        }, {
            path: '/choose-word',
            name: 'choose-word',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/choose-word")
        }, {
            path: '/reduction-word',
            name: 'reduction-word',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/reduction-word")
        }, {
            path: '/sentences-with-words',
            name: 'sentences-with-words',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/sentences-with-words")
        }, {
            path: '/short-fill-in-blanks',
            name: 'short-fill-in-blanks',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/short-fill-in-blanks")
        }, {
            path: '/reading-comprehension',
            name: 'reading-comprehension',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/reading-comprehension")
        }, {
            path: '/first-letter-filling',
            name: 'first-letter-filling',
            component: () =>
                import ("@/views/exercise-manage/makeexercises/editsmallquestion/first-letter-filling")
        }]
    },
    // 激活码管理
    {
        path: '/',
        name: 'activation-code-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [
            // 激活码管理 生成激活码
            {
                path: '/Generating',
                name: 'Generating',
                component: () =>
                    import ("@/views/activation-code-manage/Generating/index")
            },
            // 激活码管理 管理激活码
            {
                path: '/managecode',
                name: 'managecode',
                component: () =>
                    import ("@/views/activation-code-manage/managecode/index")
            },
            // 激活码管理 分发码管理
            {
                path: '/sendcode',
                name: 'sendcode',
                component: () =>
                    import ("@/views/activation-code-manage/sendcode/index")
            },
            // 激活码管理 下载码管理
            {
                path: '/downloadcode',
                name: 'downloadcode',
                component: () =>
                    import ("@/views/activation-code-manage/downloadCode/index")
            },
            // 激活码管理 教材二维码管理
            {
                path: '/bookqrcode',
                name: 'bookqrcode',
                component: () =>
                    import ("@/views/activation-code-manage/bookqrCode/index")
            },
        ]
    },
    //电商管理
    {
        path: '/',
        name: 'electricity-management',
        component: () =>
            import ("@/views/home/index"),
        children: [{
                path: '/excurriculum',
                name: 'excurriculum',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/excurriculum/index"),
            },
            {
                path: '/catalogue',
                name: 'catalogue',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/excurriculum/catalogue/index"),
            },
            {
                path: '/freeclasses',
                name: 'freeclasses',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/excurriculum/free-classes/index"),
            },
            {
                path: '/secondkill',
                name: 'secondkill',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/excurriculum/secondkill/index"),
            },
            {
                path: '/ectag',
                name: 'ectag',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/ectag/index"),
            },
            {
                path: '/recommendbook',
                name: 'recommendbook',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/recommendbook/index"),
            },
            {
                path: '/newcourse',
                name: 'newcourse',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/electricity-management/excurriculum/newcourse/index"),
            }
        ]
    },
    // 出版社管理
    {
        path: '/',
        name: 'press-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [{
                path: '/press',
                name: 'press',
                component: () =>
                    import ("@/views/press-manage/press/index"),
            },
            {
                path: '/bookgroup',
                name: 'bookgroup',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/press-manage/bookgroup/index"),
            },
            {
                path: '/textbookSeries',
                name: 'textbookSeries',
                props: route => ({...route.query }),
                component: () =>
                    import ("@/views/press-manage/press/textbookSeries/index"),
            }
        ]
    },
    // 机构管理
    {
        path: '/',
        name: 'organiza-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [{
            path: '/orglist',
            name: 'orglist',
            props: route => ({...route.query }),
            component: () =>
                import ("@/views/organiza-manage/orglist/index"),
        }]
    },
    //学生测试
    {
        path: '/',
        name: 'student-test',
        component: () =>
            import ("@/views/home/index"),
        children: [
            //规则管理
            {
                path: '/testrule',
                name: 'testrule',
                component: () =>
                    import ("@/views/student-test/testrule/index"),
            },
            //测试管理
            {
                path: '/testmangement',
                name: 'testmangement',
                component: () =>
                    import ("@/views/student-test/testmangement/index"),

            },
            {
                path: '/newTest/:miniid/:groupId',
                name: 'newTest',
                component: () =>
                    import ("@/views/student-test/testmangement/newTest/index"),
            },
            {
                path: '/lookText/:id',
                name: 'lookText',
                component: () =>
                    import ("@/views/student-test/testmangement/lookText/index"),
            },
            {
                path: '/editText/:id',
                name: 'editText',
                component: () =>
                    import ("@/views/student-test/testmangement/editText/index"),
            }
        ]
    },
    //财务管理
    {
        path: '/',
        name: 'financial-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [
            //财务对账
            {
                path: '/reconciliation',
                name: 'reconciliation',
                component: () =>
                    import ("@/views/financial-manage/reconciliation/index"),
            },
        ]
    },
    //注册管理
    {
        path: '/',
        name: 'register-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [
            //规则管理
            {
                path: '/registerAudit',
                name: 'registerAudit',
                component: () =>
                    import ("@/views/register-manage/registerAudit/index"),
            },
        ]
    },
    // PPT管理
    {
        path: '/',
        name: 'ppt-manage',
        component: () =>
            import ("@/views/home/index"),
        children: [
            // PPT管理 我的PPT列表（导入转换 + 查询 + 维护主入口，菜单挂此路径）
            {
                path: '/pptlist',
                name: 'pptlist',
                component: () =>
                    import ("@/views/ppt-manage/pptlist/index")
            },
            // PPT管理 渲染图检查页（导入 .pptx 转换产物：整页渲染预览 + 导出 HTML，不展示在菜单）
            {
                path: '/pptpreview',
                name: 'pptpreview',
                component: () =>
                    import ("@/views/ppt-manage/pptpreview/index")
            },
            // PPT管理 整页图替换编辑页（失真页用 PPT 截图整页替换：左侧缩略图 + 右侧大图，不展示在菜单）
            {
                path: '/pptedit',
                name: 'pptedit',
                component: () =>
                    import ("@/views/ppt-manage/pptedit/index")
            },
            // PPT管理 复杂PPT转换（逐页分类：普通页整页渲染 / 动画页界面补视频 / 视频页自动提取原位播放，菜单挂此路径）
            {
                path: '/pptconvert',
                name: 'pptconvert',
                component: () =>
                    import ("@/views/ppt-manage/pptconvert/index")
            }
        ]
    },

]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    let userinfo = window.sessionStorage.getItem('userinfo')
    if (!userinfo && (to.path !== '/login' && to.path !== '/register' && to.path !== '/downloadapp')) {
        return next('/login')
    }
    next()
})

export default router
